<app-card
  (toggled)="toggled.emit($event)"
  [collapsible]="true"
  [startCollapsed]="startCollapsed()"
  class="basket"
>
  <div card-header class="basket__header">
    <div class="basket__header-title">
      <span class="basket__header-summary">Summary: </span>
      <span class="basket__header-selection">
        @if (customerSelectedToPurchasePlan()) {
          Registration + Protection
        } @else {
          Registration only
        }
      </span>
    </div>

    @if (customerSelectedToPurchasePlan()) {
      @if (hasDiscountedMonths()) {
        <app-single-plan-promo-price />
      } @else {
        <h3>for {{ total() | currencyFormat }} a month</h3>
      }
    }
  </div>

  <div card-collapsible class="basket__collapsible">
    <app-basket-appliance>
      <div slot="title">
        {{ clientName }} {{ steppedFormAppliance()?.applianceName }}
      </div>
      <div slot="body">Your registered appliance</div>
    </app-basket-appliance>

    @if (customerSelectedToPurchasePlan()) {
      <app-basket-appliance [canRemoveAppliance]="true">
        <div slot="title">{{ clientName }} Appliance Care</div>
        <div slot="body">
          For your {{ steppedFormAppliance()?.applianceName }}
        </div>
      </app-basket-appliance>

      <div class="basket__payment-summary">
        @if (hasDiscountedMonths()) {
          <div class="basket__payment-summary-discounts">
            <p class="basket__payment-summary-discounts-label">
              First {{ numberOfDiscountedMonths() }} monthly payments
            </p>
            <p class="basket__payment-summary-discounts-value">FREE</p>
          </div>

          <div class="basket__payment-summary-price">
            <p class="basket__payment-summary-price-label">
              Total monthly payment once the offer ends
            </p>
            <p class="basket__payment-summary-price-value">
              {{ quoteMonthlyPayment().subsequentPayment | currencyFormat }}
            </p>
          </div>
        } @else {
          <div class="basket__payment-summary-price">
            <p class="basket__payment-summary-price-label">
              Total monthly payment
            </p>
            <p class="basket__payment-summary-price-value">
              {{ quoteMonthlyPayment().subsequentPayment | currencyFormat }}
            </p>
          </div>
        }
        <div class="basket__payment-summary-cancel-anytime">Cancel anytime</div>
      </div>

      <div class="basket__disclaimer">
        Price includes any applicable Insurance Premium Tax or VAT and is
        subject to any inflation and tax rate changes.
      </div>
    }
  </div>
</app-card>
